import FarmerPage from'./FarmerPage'

export default FarmerPage;